<div class="mobile-footer-navigation d-block d-md-none fixed-bottom">
  <div class="nav-container bg-white">
    <div class="row m-0">
      <div class="col p-0">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'home'}">
          <a class="d-flex flex-column align-items-center text-decoration-none" 
             [ngClass]="activeNavItem === 'home' ? 'text-primary' : 'text-muted'"
             routerLink="/dashboard" 
             routerLinkActive="active"
             (click)="navigateToHome()">
            <img src="assets/icons/homeicons.svg" />
            <span class="small">Home</span>
          </a>
        </div>
      </div>
      <div class="col p-0">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'search'}">
          <a class="d-flex flex-column align-items-center text-decoration-none"
             [ngClass]="activeNavItem === 'search' ? 'text-primary' : 'text-muted'"
             (click)="navigateToSearch()">
            <img src="assets/icons/iconamoon_search.svg" />
            <span class="small">Search</span>
          </a>
        </div>
      </div>

      <!-- Reception/Security > Add Visit for Host -->
      <!-- <div class="col p-0" *ngIf="constants.hasModulePermission('Create_Visit','ADD')">
        <div class="nav-item text-center py-2">
          <div class="add-button-container">
            <a  class="add-button d-flex align-items-center justify-content-center rounded-circle text-white" routerLink="/create-visit-by-reception">
              <img src="assets/icons/Add_Plus.svg" />
            </a>
          </div>
        </div>
      </div> -->

      <div class="col p-0" *ngIf="constants.hasModulePermission('Create_Visit','ADD')">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'add'}">
          <div class="add-button-container">
            <a class="add-button d-flex align-items-center justify-content-center rounded-circle text-white add-for-host" 
              [class.active]="isMenu2Open" (click)="toggleMenuForReception()">
              <img src="assets/icons/Add_Plus.svg" />
            </a>
          </div>
        </div>
      </div>

      <!-- Backdrop -->
     <div class="backdrop" *ngIf="isMenu2Open" (click)="toggleMenuForReception()"></div>

      <!-- FAB and Floating Menu -->
      <div class="fab-container" [style.display]="isMenu2Open ? 'flex' : 'none'">
        <div class="floating-menu" [class.active]="isMenu2Open">
          <div class="menu-item" (click)="navigateToCreateVisit()">
            <div class="menu-icon visit"><i class="bi bi-person-plus fs-5 text-indigo"></i></div>
            <span>Add Visit for Host</span>
          </div>
        </div>
      </div>

      <!-- QR -->
      <div class="col p-0" *ngIf="constants.hasModulePermission('Scan_QR','LIST')" (click)="openScanner = true">
        <div class="nav-item text-center py-2">
          <a class="d-flex flex-column align-items-center text-decoration-none">
            <i class="bi bi-qr-code-scan" title="Scan QR code" style="font-size: 19px; color: #b2b2b2;"></i>
            <span class="small">Scan QR</span>
          </a>
        </div>
      </div>

      <!-- Floating Action Button -->
      <div class="col p-0" *ngIf="constants.hasModulePermission('Visit','ADD')">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'add'}">
          <div class="add-button-container">
            <a class="add-button d-flex align-items-center justify-content-center rounded-circle text-white" 
              [class.active]="isMenuOpen" (click)="toggleMenu()">
              <img src="assets/icons/Add_Plus.svg" />
            </a>
          </div>
        </div>
      </div>

      <!-- Floating Action Button -->
      <!-- <div class="col p-0" *ngIf="constants.hasModulePermission('Scan_QR','LIST')" (click)="openScanner = true">
        <div class="nav-item text-center py-2">
          <div class="add-button-container">
            <a class="add-button d-flex align-items-center justify-content-center rounded-circle text-white" 
              [class.active]="isMenuOpen">
              <i class="bi bi-qr-code-scan" title="Scan QR code" style="font-size: 24px;"></i>
            </a>
          </div>
        </div>
      </div> -->

     <!-- Backdrop -->
     <div class="backdrop" *ngIf="isMenuOpen" (click)="toggleMenu()"></div>

     <!-- FAB and Floating Menu -->
      <div class="fab-container" [style.display]="isMenuOpen ? 'flex' : 'none'">
        <div class="floating-menu" [class.active]="isMenuOpen">
          <div class="menu-item" (click)="shareVia('whatsapp')">
            <div class="menu-icon whatsapp"><i class="bi bi-whatsapp fs-5 text-success"></i></div>
            <span>Invite via WhatsApp</span>
          </div>
          <div *ngIf="isMobile" class="menu-item" (click)="shareVia('sms')">
            <div class="menu-icon sms"><i class="bi bi-chat-dots fs-5 text-info"></i></div>
            <span>Invite via SMS</span>
          </div>
          <div class="menu-item" (click)="copyLink()">
          <div class="menu-icon link">
            <div *ngIf="isLinkGenerating" class="spinner-border spinner-border-sm" role="status"></div>
            <i *ngIf="!isLinkGenerating && !linkCopied" class="bi bi-copy fs-4 copy-icon" title="Copy Invite Link" style="padding-top: 2px; color:#00bfff"></i>
            <i *ngIf="!isLinkGenerating && linkCopied" class="bi bi-check-circle-fill fs-5 text-success" title="Copied!"></i>
          </div>
          <span>{{ isLinkGenerating ? 'Generating link...' : 'Copy Invite Link' }}</span>
          </div>
          <div class="menu-item" (click)="proceedToRequestDetails()">
            <div class="menu-icon email"><i class="bi bi-envelope fs-5 text-primary"></i></div>
            <span>Invite via Email</span>
          </div>
          <div class="menu-item" (click)="navigateToAddVisit()">
            <div class="menu-icon visit"><i class="bi bi-person-plus fs-5 text-indigo"></i></div>
            <span>Add Visit</span>
          </div>
        </div>
      </div>

      <!-- Request details via Email -->
      <div *ngIf="showRequestDetailsModal" class="main-modal">
        <div class="modal-main-content request-details-content rounded-4 p-2">
          <form #requestDetailsForm="ngForm" (ngSubmit)="requestDetailsForm.valid && requestDetails()" novalidate>
            <div class="modal-header-section align-items-center px-4 py-3 rounded-4 modal-lg">
              <h5 class="modal-heading mb-0">Invitation Details</h5>
              <button class="btn-close text-end" type="button" (click)="closeRequestDetailsModal()"></button>
            </div>
      
            <div class="modal-body d-flex flex-column justify-content-center px-4 py-4">
      
              <div class="row">
                <!-- Receiver Email -->
                <div class="col-md-12">
                  <div class="form-group">
                    <input type="email" id="receiverEmail" name="receiverEmail" class="form-control"
                      [(ngModel)]="visitInvitation.receiverEmail" required pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                      #receiverEmail="ngModel" placeholder="Receiver email"
                      [ngClass]="{'is-invalid': receiverEmail.invalid && (receiverEmail.touched || requestDetailsForm.submitted)}">
                    <div class="invalid-feedback"
                      *ngIf="receiverEmail.invalid && (receiverEmail.touched|| requestDetailsForm.submitted)">
                      <span *ngIf="receiverEmail.errors?.['required']">Email is required</span>
                      <span *ngIf="receiverEmail.errors?.['pattern']">Please enter a valid email</span>
                    </div>
                  </div>
                </div>
      
              </div>
            </div>
      
            <div class="modal-footer gap-3 px-4 py-3 border-0">
              <button type="button" class="no-btn button-animations cancel-button"
                (click)="closeRequestDetailsModal()">Back</button>
              <button type="submit" class="yes-btn button-animations" [disabled]="formSubmitLoader2">
                <span *ngIf="formSubmitLoader2" class="spinner-border spinner-border-sm me-1" role="status"
                  aria-hidden="true"></span>Send</button>
            </div>
          </form>
        </div>
      </div>
      
      <!-- ///////////////////////////// -->

      <div class="col p-0" *ngIf="constants.hasModulePermission('Visit','LIST')">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'pending'}">
          <a class="d-flex flex-column align-items-center text-decoration-none"
             [ngClass]="activeNavItem === 'pending' ? 'text-primary' : 'text-muted'" 
             (click)="viewVisitsByStatus('Pending_Approvals')">
            <img src="assets/icons/ion_alert-outline.svg" />
            <span class="small">Pending</span>
          </a>
        </div>
      </div>
      <div class="col p-0">
        <div class="nav-item text-center py-2" [ngClass]="{'active': activeNavItem === 'menu'}">
          <a (click)="toggleSidebar()" 
             class="sidebartoggler d-flex flex-column align-items-center text-decoration-none"
             [ngClass]="activeNavItem === 'menu' ? 'text-primary' : 'text-muted'">
            <img src="assets/icons/menubottom.svg" />
            <span class="small">Menu</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<app-qr-scanner *ngIf="openScanner" (scanned)="handleScan($event)" />